/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetMerchantDefaultBrandRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {GetMerchantDefaultBrandResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const getMerchantDefaultBrand = (request: GetMerchantDefaultBrandRequest, options?: CashRequestOptions) => post<GetMerchantDefaultBrandRequest, GetMerchantDefaultBrandResponse>("/2.0/cash/get-merchant-default-brand", request, {...options, rejectOnError: true })